import { useEffect, useState } from "react";

const useIsOneTrustOpen = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const isVisible = (el: Element) =>
      window.getComputedStyle(el).display !== "none";

    let styleObserver: MutationObserver | null = null;
    let domObserver: MutationObserver | null = null;

    const setupStyleObserver = (element: Element) => {
      setIsOpen(isVisible(element));

      styleObserver = new MutationObserver(() => {
        setIsOpen(isVisible(element));
      });

      styleObserver.observe(element, {
        attributes: true,
        attributeFilter: ["style"],
      });
    };

    const checkForOneTrust = () => {
      const element = document.querySelector(".onetrust-pc-dark-filter");
      if (element) {
        setupStyleObserver(element);
        domObserver?.disconnect();
        return true;
      }
      return false;
    };

    // Check if OneTrust is already present
    if (checkForOneTrust()) {
      return () => styleObserver?.disconnect();
    }

    // If not present, watch for it to be added to the DOM
    domObserver = new MutationObserver(checkForOneTrust);
    domObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => {
      domObserver?.disconnect();
      styleObserver?.disconnect();
    };
  }, []);

  return isOpen;
};

export default useIsOneTrustOpen;
